import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'dineInTables/';

const initialState = {
    tables: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const fetchDineInTables = createAsyncThunk(
    'dineInTables/fetchAll',
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(API_URL + 'list');
            return res.data.tables || [];
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createDineInTable = createAsyncThunk(
    'dineInTables/create',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + 'create', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateDineInTable = createAsyncThunk(
    'dineInTables/update',
    async ({ reservationID, data }, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + `update/${reservationID}`, data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteDineInTable = createAsyncThunk(
    'dineInTables/delete',
    async (reservationID, thunkAPI) => {
        try {
            const res = await axios.delete(API_URL + `delete/${reservationID}`);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const dineInTableSlice = createSlice({
    name: 'dineInTables',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDineInTables.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchDineInTables.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.tables = action.payload;
            })
            .addCase(fetchDineInTables.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createDineInTable.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createDineInTable.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(createDineInTable.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateDineInTable.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateDineInTable.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updateDineInTable.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteDineInTable.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteDineInTable.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(deleteDineInTable.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = dineInTableSlice.actions;
export default dineInTableSlice.reducer;